import Vue from 'vue'
import Element from "element-ui";
import "@/styles/ruoyi.scss"; // ruoyi css
import Cookies from "js-cookie";
import { getScaleNum } from "@/utils/index.js"

const scaleNum = getScaleNum();
document.documentElement.style.setProperty("--scale", scaleNum);
if (process.env.NODE_ENV != "development") {
  document.addEventListener('DOMContentLoaded', () => {
    const meta = document.createElement('meta');
    meta.content = `upgrade-insecure-requests`;
    meta.httpEquiv = 'Content-Security-Policy'
    meta.name = "http-https"
    document.getElementsByTagName('head')[0].appendChild(meta);
  })
}

const baseSize = 16
// 设置 rem 函数
function setRem() {
  // 当前页面宽度相对于1920宽的缩放比例, 可根据自己需要修改
  const scale = document.documentElement.clientWidth / 1920
  // 设置页面根节点字体大小, 字体大小最小为12
  const fontSize = baseSize * Math.min(scale, 2) > 12 ? baseSize * Math.min(scale, 2) : 12
  document.documentElement.style.fontSize = fontSize + 'px'
}
// 初始化
setRem()
// 改变窗口大小重新设置rem
window.onresize = function() {
  setRem()
}

Vue.use(Element, {
  size: Cookies.get("size") || "medium" // set element-ui default size
});

